var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.partnerCode==='uzima_ug')?_c('UzimaUg'):(_vm.domain==='milk')?_c('MilkCollection'):_c('Default')
}
var staticRenderFns = []

export { render, staticRenderFns }